import AddLinkIcon from '@mui/icons-material/AddLink';
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import Stack from '@mui/material/Stack';
import Button from 'components/Button/Button';
import { ClockFastIcon } from 'components/icons';
import { bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import React from 'react';
import LinkAttachmentPopover from './LinkAttachmentPopover';
import MediaAttachment from './MediaAttachment';
import QuickRepliesPopover from './QuickRepliesPopover';

const AttachmentToolbar = ({
  onLinkSelect,
  onFileSelect,
  onQuickReplySelect,
  type,
}) => {
  const linkPopupState = usePopupState({
    variant: 'popover',
    popupId: 'linkAttachmentPopover',
  });
  const quickReplyPopupState = usePopupState({
    variant: 'popover',
    popupId: 'quickReply',
  });

  const onReplySelect = (item) => {
    quickReplyPopupState.close();
    onQuickReplySelect(item);
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {onFileSelect && <MediaAttachment onSelect={onFileSelect} />}
      <Button
        rounded
        {...bindTrigger(linkPopupState)}
        size="small"
        variant="text"
        color="secondary"
        startIcon={<AddLinkIcon />}
      >
        Links
      </Button>
      {onQuickReplySelect && (
        <Button
          rounded
          {...bindTrigger(quickReplyPopupState)}
          size="small"
          variant="text"
          color="secondary"
          startIcon={<ClockFastIcon />}
        >
          Templates
        </Button>
      )}
      <LinkAttachmentPopover
        popupState={linkPopupState}
        onSelect={onLinkSelect}
      />
      <QuickRepliesPopover
        type={type}
        popupState={quickReplyPopupState}
        onSelect={onReplySelect}
      />
    </Stack>
  );
};

export default AttachmentToolbar;
